import './book-share.scss';
import Cookies from 'js-cookie';


class BookShareManager {
  // All configurable selectors.
  myBookmarkToggleSelectors = '.js-my-folder-toggle';
  actionBookmarkSelectors = '.js-action-bookmark';
  bookmarksContainerSelector = '#bookmark-list';
  activeBookmarkClass = 'active-bookmark';
  sharedFolderLinkSelector = '.bookmark-selector-content .js-shared-folder-link';
  sharedFolderLinkSingleSelectors = '.bookmark-sidebar .js-shared-folder-link-single'
  folderCountSelectors = '.js-folder-count';
  bookmarksBlockSelector = '#block-solliocustombookmarkblock .bookmark-selector-content';
  bookmarksRemoveSelector = '.js-action-bookmark-remove';
  relatedArticleContainerSelector = '.related-articles';
  innovationArticleContainerSelector = '.node--type-innovation';
  hubNouvelleContainerSelector = '.page-node-type-hub-nouvelles';

  // Object variables for states management.
  cookieName = 'visitor-bookmark';
  bookmarksCount = 0;
  sidePanelIsOpen = false;
  isDetaillantPage = false;
  eventOnlyOnce = true;

  // All components to be initialised in the constructor bellow.
  toggleComponentsList = null;
  bookmarksList = null;
  bookmarksContainerComponent = null;
  actionBookmarkLists = null;
  sharedFolderLinkComponent = null;
  sharedFolderLinkSingleComponents = null;
  foldersCountList = null;
  bookmarksBlockComponent = null;
  bookmarksRemoveComponent = null;

  constructor() {
    if (document.querySelector('.detaillant-toolbar-container')) {
      this.isDetaillantPage = true;
    }
    this.toggleComponentsList = document.querySelectorAll(this.myBookmarkToggleSelectors);

    this.bookmarksContainerComponent = document.querySelector(this.bookmarksContainerSelector);

    if (document.querySelector(this.sharedFolderLinkSelector)) {
      this.sharedFolderLinkComponent = document.querySelector(this.sharedFolderLinkSelector);
    }
    this.foldersCountList = document.querySelectorAll(this.folderCountSelectors);
    this.bookmarksBlockComponent = document.querySelector(this.bookmarksBlockSelector);
    // Special case load async if we have related articles.
    this.init();
    this.initAsync();
    if (document.querySelector(this.relatedArticleContainerSelector) || document.querySelector(this.innovationArticleContainerSelector) || document.querySelector(this.hubNouvelleContainerSelector)) {
      document.addEventListener('relatedLoaded', () => {
        this.initAsync();
      });
    }
  }

  init() {
    this.addMyBookmarkToggleListener();
    this.makeAjaxCall();
    this.updateCount();
    this.shareCopyToClipboard();
    this.addDeleteCurrentBookmarkEventListener();
    this.addSharedFolderSingleEventListeners();
  }

  initAsync() {
    this.actionFolders();
  }

  actionFolders() {
    this.actionBookmarkLists = document.querySelectorAll(this.actionBookmarkSelectors);
    const _self = this;
    if (this.actionBookmarkLists) {
      this.actionBookmarkLists.forEach(folder => {
        this.displayActiveBookmark(folder);
        let folderEvent = folder._getEventListeners();
        // Only add events if no event listener on object.
        if (!window.eventListener._hasEvents(folderEvent)) {
          folder.addEventListener('click', handleActionFolders, false);
        }

        function handleActionFolders(evt) {
          evt.preventDefault();
          const dataId = folder.dataset.id.trim();
          if (_self.checkIfValueIsInCookie(dataId)) {
            _self.cookieSettings('delete', dataId);
            folder.classList.remove(_self.activeBookmarkClass);
            _self.displayActiveBookmark(folder);
            _self.checkActionFolderWithSameId(folder);
          } else {
            _self.sendDataToDataLayer(folder);
            _self.cookieSettings('update', dataId);
            folder.classList.add(_self.activeBookmarkClass);
            _self.displayActiveBookmark(folder);
            _self.checkActionFolderWithSameId(folder);
          }
          _self.makeAjaxCall();
        }
      });
    }
  }

  checkActionFolderWithSameId(folder) {
    const dataId = folder.dataset.id.trim();
    const selectors = document.querySelectorAll(`[data-id="${dataId}"]`);
    selectors.forEach((selector) => {
      if (selector.classList.contains(this.activeBookmarkClass) && selector !== folder) {
        selector.classList.remove(this.activeBookmarkClass)
      } else if (selector !== folder) {
        selector.classList.add(this.activeBookmarkClass)
      }
      this.displayActiveBookmark(selector);
    })
  }

  updateCount() {
    const arr = this.getCookie(this.cookieName);
    const nb = arr.length;

    this.foldersCountList.forEach(bookmark => {
      bookmark.textContent = nb;
    });
    this.sharedFolderLinks();

  }

  sharedFolderLinks() {
    if (document.querySelector(this.sharedFolderLinkSelector)) { // main share folder sidebar
      const url = new URL(`${window.location.origin}${this.sharedFolderLinkComponent.dataset.baseurl}`);
      url.search = '';
      url.searchParams.set('bookmarks', this.encodedCookieValues());
      this.sharedFolderLinkComponent.href = url.toString();
      let componentEvent = document.querySelector(this.sharedFolderLinkSelector)._getEventListeners();
      if (!window.eventListener._hasEvents(componentEvent)) {
        this.sharedFolderLinkComponent.addEventListener('click', (_e) => {
          _e.preventDefault();
          this.sendShareLinkToDataLayer(this.sharedFolderLinkComponent.href.toString(), this.sharedFolderLinkComponent.innerText.replace(/\([^)]+\)/g, '').trim(), 'Partager ma filière', null);

          const individalBookmark = document.querySelectorAll('#bookmark-list .bookmark-page__single');
          individalBookmark.forEach((selector) => {
            const link = selector.querySelector('h5 a');
            if (link) {
              this.sendShareLinkToDataLayer(link.href, null, null, link.textContent.trim());
            }
          })

          navigator.clipboard.writeText(this.sharedFolderLinkComponent.href.toString()).then(_r => {
            this.showToast();
          });

        });
      }

    }
  }

  sendDataToDataLayer(folder) { //UCS010 - Add to folder
    const baseURL = window.location.protocol + "//" + window.location.hostname;
    window.dataLayer.push({
      "event": "user_interaction",
      "event_name": "add_to_folder",
      "interaction": {
        "link_url": baseURL + folder.getAttribute('data-url'),
        "link_title": folder.getAttribute('data-title').replace(/&#039;/g, "'")
      }
    });
  }

  sendShareLinkToDataLayer(link, $text, $textFr, $title) { //UCS009 - Content sharing
    window.dataLayer.push({
      "event": "user_interaction",
      "event_name": "share",
      "interaction": {
        "link_url": link,
        "link_title": $title,
        "link_text": $text,
        "link_text_fr": $textFr
      }
    });
  }

  addSharedFolderSingleEventListeners() {
    let _self = this;
    this.sharedFolderLinkSingleComponents = document.querySelectorAll(this.sharedFolderLinkSingleSelectors); // sidebar bookmark
    this.sharedFolderLinkSingleComponents.forEach((component) => {
      let componentEvent = component._getEventListeners();
      // Only add events if no event listener on object.
      if (!window.eventListener._hasEvents(componentEvent)) {
        component.addEventListener('click', (_e) => {
          _e.preventDefault();
          this.sendShareLinkToDataLayer(component.href, null, null, component.closest('.bookmark-sidebar').querySelector('.bookmark-sidebar__title h5').textContent.trim());
          navigator.clipboard.writeText(component.href).then(_r => {
            _self.showToast();
          });
        });
      }
    });
  }

  shareCopyToClipboard = () => {
    const shareBtn = document.querySelectorAll('.copy-share'); // on pages
    shareBtn.forEach(btn => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        this.sendShareLinkToDataLayer(window.location.href, null, null, document.getElementsByTagName("h1")[0] ? document.getElementsByTagName("h1")[0].textContent : null);
        navigator.clipboard.writeText(window.location.href).then(_r => {
          this.showToast();
        });
      });
    })
  }

  showToast() {
    const toast = document.getElementById('shareCopiedToast');
    toast.classList.toggle('show');
    setTimeout(function () {
      toast.classList.toggle('show');
    }, 3000);
  }

  cookieSettings(action, id) {
    const arr = this.getCookie(this.cookieName);
    const index = arr.indexOf(id);
    if (action === 'update') {
      if (arr.length !== 0) {
        if (index === -1) {
          arr.push(id);
        }
      } else {
        arr.push(id)
      }
      this.setCookie(this.cookieName, JSON.stringify(arr));
    } else {
      if (index !== -1) {
        arr.splice(index, 1);
      }
      this.setCookie(this.cookieName, JSON.stringify(arr));
    }
    this.updateCount();
  }

  checkIfValueIsInCookie(id) {
    const arr = this.getCookie(this.cookieName);
    if (arr.length !== 0) {
      const index = arr.indexOf(id);
      if (index !== -1) {
        return true;
      }
    }
    return false
  }

  setCookie(name, value) {
    Cookies.set(name, value, {path: '/'});
  }

  getCookie(name) {
    const cookieValue = Cookies.get(name);
    if (cookieValue) {
      return JSON.parse(cookieValue);
    }
    return [];
  }

  openBookmarkPanel() {
    this.bookmarksBlockComponent.classList.add('open');
    document.body.classList.add('prevent-scroll');
    this.addDeleteCurrentBookmarkEventListener();
    this.addSharedFolderSingleEventListeners();
    document.getElementById('book-share-overlay').style.display = 'block';
    this.sidePanelIsOpen = true;
  }

  closeBookmarkPanel() {
    this.bookmarksBlockComponent.classList.remove('open');
    document.body.classList.remove('prevent-scroll');
    document.getElementById('book-share-overlay').style.display = 'none';
    this.sidePanelIsOpen = false;
  }

  addMyBookmarkToggleListener() {
    let _self = this;
    this.toggleComponentsList.forEach((component) => {
      component.addEventListener('click', (event) => {
        event.preventDefault();

        if (this.sidePanelIsOpen) {
          _self.closeBookmarkPanel();
        } else {
          _self.openBookmarkPanel();
        }
      });
    });

    // Close bookmark panel when clicking on overlay (outside panel).
    const bookmarkOverlay = document.getElementById('book-share-overlay');
    if (bookmarkOverlay) {
      bookmarkOverlay.addEventListener('click', (event) => {
        event.preventDefault();
        _self.closeBookmarkPanel();
      });
    }
  }

  displayActiveBookmark(folder) {
    const dataId = folder.dataset.id.trim();
    const imgElement = folder.querySelector('.js-action-bookmark img');
    const imgOption = {};


    //Dark theme detaillant
    if (this.isDetaillantPage) {
      imgOption.off = '/themes/custom/sollio/images/icons/icon-filiere-ajout-dark-theme.svg';
      imgOption.on = '/themes/custom/sollio/images/icons/icon-filiere-actif.svg';
    } else {
      imgOption.off = '/themes/custom/sollio/images/icons/icon-filiere-ajout.svg';
      imgOption.on = '/themes/custom/sollio/images/icons/icon-filiere-actif.svg';
    }
    if (!this.checkIfValueIsInCookie(dataId)) {
      folder.classList.remove(this.activeBookmarkClass);
      if (imgElement) {
        imgElement.src = imgOption.off;
        imgElement.classList.remove('active');
      }
    } else {
      folder.classList.add(this.activeBookmarkClass);
      if (imgElement) {
        imgElement.src = imgOption.on;
        imgElement.classList.add('active');
      }

    }


  }

  addDeleteCurrentBookmarkEventListener() {
    this.bookmarksRemoveComponent = document.querySelectorAll(this.bookmarksRemoveSelector);
    this.bookmarksRemoveComponent.forEach((component) => {
      let componentEvent = component._getEventListeners();
      if (!window.eventListener._hasEvents(componentEvent)) {
        component.addEventListener('click', () => {
          const dataId = component.dataset.id.trim();
          this.cookieSettings('delete', dataId);
          this.displayActiveBookmark(component);
          this.checkActionFolderWithSameId(component);
          component.parentElement.parentElement.remove();
          this.actionFolders();
        });
      }
    });

  }

  makeAjaxCall() {
    const vm = this;
    const xhr = new XMLHttpRequest();
    xhr.open('POST', Drupal.url('views/ajax'), true);
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        if (response[3] !== undefined) {
          vm.bookmarksContainerComponent.innerHTML = response[3].data;
        }
      }
    };
    xhr.send('view_name=sollio_bookmark&view_display_id=sidebar&bookmarks=' + this.encodedCookieValues());
  }

  encodedCookieValues() {
    return this.getCookie(this.cookieName).join(',');
  }
}

window.addEventListener('load', () => {
  new BookShareManager();
});
